import querystring from 'querystring';
import axios from 'axios';
import { API } from '../utils/constants';
import { setAntiForgeryToken } from '../utils/forms';

export const validatePhoneNumberWithIso = async ({
  countryISOCode2,
  phoneNumber,
}) => {
  const params = querystring.encode({ countryISOCode2, phoneNumber });
  const url = `${API.PHONE_VALIDATION}${params}`;
  const response = await axios
    .post(url)
    .then(() => [null, true])
    .catch(error => [error, false]);

  return response;
};

export const postEnquiryData = (values, antiForgeryData) => {
  return axios
    .post(API.ENQUIRY, setAntiForgeryToken(antiForgeryData, values))
    .then(({ data }) => [null, data])
    .catch(error => [error, null]);
};
